<template>
  <section v-if="loaded">
    <h1>Banners List</h1>
    <div class="my-3">
      <v-layout row wrap>
        <v-flex xs6 fluid align-center justify-center>

          <!--MODAL WINDOW ADD BANNER-->
          <v-dialog persistent v-model="modalWindow" max-width="800">
            <v-btn color="primary" dark slot="activator" class="mb-2" v-if="isWriteAvailable">Add Banner</v-btn>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }} </span>
              </v-card-title>
              <v-card-media v-if="formData.images.desktopImage" :src="formData.images.desktopImage" height="200"/>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>

                    <v-flex xs12>
                      <content-field
                        label="Advertising URL"
                        @blur="$v.formData.url.$touch()"
                        :error="$v.formData.url"
                        v-model="formData.url"
                      />
                    </v-flex>

                    <v-flex xs12>
                      <content-field
                        label="Name"
                        multiLine
                        :error="$v.formData.metadataObject.description"
                        @blur="$v.formData.metadataObject.description.$touch()"
                        v-model="formData.metadataObject.description"
                      />
                    </v-flex>

                    <v-flex xs12>
                      <v-btn color="success" @click="toggleModal">Choose Banner</v-btn>
                      <v-btn :disabled="!formData.url" color="success" @click="resetIcon">Remove Banner</v-btn>
                      <span class="red--text" v-if="$v.formData.images.desktopImage.$dirty && $v.formData.images.desktopImage.$invalid">Please select image</span>
                    </v-flex>

                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" flat @click.stop="close">Cancel</v-btn>
                <v-btn color="blue darken-1" flat @click.stop="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-btn color="primary" @click="reset">Reset</v-btn>
          <!--MODAL WINDOW ADD BANNER-->

          <!--MODAL WINDOW ADD BANNER-->
          <v-dialog v-model="modalGallery">
            <galleries-list :modalView="true" @pickedImage="setImage"/>
          </v-dialog>
          <!--MODAL WINDOW ADD BANNER-->

        </v-flex>

        <!--SEARCH-->
        <v-flex xs2 offset-xs4>
          <v-text-field
            append-icon="search"
            label="Search"
            v-model="filterInput"
          ></v-text-field>
        </v-flex>
        <!--SEARCH-->

      </v-layout>

      <!--TABLE-->
      <v-data-table
        :headers="headers"
        :items="getBannersList"
        class="elevation-1 wrap"
        :pagination.sync="pagination"
        :total-items="totalItemsInTable"
        item-key="id"
        disable-initial-sort
      >
        <template slot="items" slot-scope="props">

          <td class="text-xs-center">
            <v-avatar><img
              :src="props.item.images.desktopImage || 'http://via.placeholder.com/350x200.jpg'"
              alt="no image"
            >
            </v-avatar>
          </td>

          <td class="text-xs-center">
            <p>{{props.item.metadataObject.description}}</p>
          </td>

          <td class="text-xs-center">
            <v-tooltip bottom>
              <v-btn color="lime"
                :disabled="!isWriteAvailable"
                fab flat
                slot="activator"
                @click.stop="editItem(props.item)"
              >
                <v-icon>create</v-icon>
              </v-btn>
              <span>Edit</span>
            </v-tooltip>
          </td>

          <td class="text-xs-center">
            <v-tooltip bottom>
              <v-btn
                color="error"
                :disabled="!isWriteAvailable"
                fab flat
                slot="activator"
                @click.stop="removeBanner(props.item)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
              <span>Delete</span>
            </v-tooltip>
          </td>

        </template>
        <template slot="pageText" slot-scope="{}">
          Page {{pagination.page}} of {{ getTotalBannersPages }}
        </template>
      </v-data-table>
      <!--TABLE-->

    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import GalleriesList from '@/components/pages/Gallery/GalleriesList'
import ContentField from '@/components/shared/ContentField/index.vue'
import { required, url, numeric, minValue } from 'vuelidate/lib/validators'
import debounce from 'lodash.debounce'
import { equals, clone } from 'ramda'
import { timeSettings } from '@/modules/settings/'
import mixins from '@/utils/mixins'

export default {
  name: 'BannersList',
  mixins: [mixins.isWriteAvailable],
  components: {
    ContentField,
    GalleriesList
  },
  data () {
    return {
      loaded: false,
      headers: [
        {text: 'Banner', value: 'banner', align: 'center', search: false, sortable: false, width: 500} ,
        {text: 'Name', value: 'description', align: 'center', search: true, sortable: false, width: 400},
        { text: 'Edit', search: false, sortable: false, align: 'center', width: 150 },
        { text: 'Delete', search: false, sortable: false, align: 'center', width: 150 }
      ],
      filterInput: '',
      pagination: {
        rowsPerPage: 5
      },
      modalWindow: false,
      modalGallery: false,
      formData: {
        url: '',
        targetBlank: true,
        images: {
          tabletImage: '',
          mobileImage: '',
          desktopImage: ''
        },
        size: {
          width: 0,
          height: 0
        },
        margin: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
        metadataObject: {
          description: ''
        }
      },
      defaultFormData: {},
      isEditedItem: false,
      // DON'T DELETE! need for isWriteAvailable mixin
      scopeForWrite: 'awards:write'
    }
  },
  validations: {
    formData: {
      url: {required, url},
      metadataObject: {
        description: {required}
      },
      images: {
        desktopImage: {required, url}
      }
    }
  },
  computed: {
    ...mapGetters([
      'getBannersList',
      'getTotalBannersPages',
      'getTotalBannersItems'
    ]),
    formTitle () {
      return this.isEditItem ? 'Edit Banner' : 'New Banner'
    },
    totalItemsInTable () {
      return this.getTotalBannersItems || (this.getTotalBannersPages * this.pagination.rowsPerPage)
    }
  },
  watch: {
    modalWindow (val) {
      if (!val) this.close()
    },
    pagination: {
      handler (val, oldVal) {
        if (oldVal && !this.isPaginationChanged(val, oldVal)) return
        this.fetchBannersList()
      },
      deep: true
    },
    filterInput () {
      this.fetchBannersList()
    }
  },
  methods: {
    ...mapActions([
      'fetchBanners',
      'createBanner',
      'updateBanner',
      'deleteBanner',
      'showResultErrorMessage'
    ]),
    toggleModal () {
      this.$v.formData.images.desktopImage.$touch()
      this.modalGallery= true
    },
    resetIcon () {
      this.formData.images.desktopImage = ''
    },
    resetFormData () {
      this.formData = {
        url: '',
        targetBlank: true,
        images: {
          tabletImage: '',
          mobileImage: '',
          desktopImage: ''
        },
        size: {
          width: 0,
          height: 0
        },
        margin: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
        metadataObject: {
          description: ''
        }
      }
    },
    editItem (item) {
      console.log('item', item)
      this.isEditItem = true
      this.formData = {...item}
      this.modalWindow = true
      this.$v.formData.url.$touch()
    },
    async removeBanner (item) {
      await this.deleteBanner(item.id)
      this.fetchBannersList()
    },
    close () {
      this.$v.formData.$reset()
      this.modalWindow = false
      this.isEditItem = false
      setTimeout(this.resetFormData, 500)
    },
    async save () {
      this.$v.formData.$touch()
      if (this.$v.formData.$invalid) return

      if (this.isEditItem) {
        try {
          await this.updateBanner(this.formData)
          this.close()
          this.fetchBannersList()
        } catch (err) {
          throw err
        }
      } else {
        try {
          await this.createBanner(this.formData)
          this.close()
          this.fetchBannersList()
        } catch (err) {
          throw err
        }
      }
    },
    reset () {
      this.filterInput = ''
      this.pagination.sortBy = null
      this.pagination.descending = false
      this.fetchBannersList()
    },
    setImage (item) {
      this.formData.images.desktopImage = item.imagesUrls.originalImageUrl
      this.modalGallery = false
    },
    fetchBannersList: debounce(async function () {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      let itemsOnPage = equals(rowsPerPage, -1) ? this.getTotalBannersItems : rowsPerPage
      const sort = descending ? 'Desc' : 'Asc'
      const name = sortBy ? sortBy[0].toUpperCase() + sortBy.slice(1) : null
      const newPage = page - 1
      const pageCheck = newPage > 0 ? newPage : 0
      const getParams = {
        page: pageCheck,
        itemsOnPage,
        filter: this.filterInput,
        sort,
        name
      }
      await this.fetchBanners(getParams)
      this.loading = false
    }, timeSettings.delayTime),
    async addLocation (item) {
      try {
        await this.addLocationList({...item})
        await this.fetchBannersList()
        this.modalWindow = false
      } catch (err) {
        this.showResultErrorMessage(err)
      }
    },
    isPaginationChanged (val, oldVal) {
      return val.rowsPerPage !== oldVal.rowsPerPage ||
        val.sortBy !== oldVal.sortBy ||
        val.descending !== oldVal.descending ||
        val.page !== oldVal.page
    }
  },
  async created () {
    await this.fetchBanners()
    await this.fetchBannersList()
    this.loaded = true
  }
}
</script>

<style type="scss">
.arrow {
  margin: 0 -10px;
}

.arrow i {
  font-size: 16px;
}

.selected-color-box {
  display: inline-block;
  width: 27px;
  height: 27px;
  margin-left: 10px;
  border-radius: 2px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Banners/List/index.vue